module.exports = __webpack_public_path__ + "static/media/step-3.14e33200.webp";